import React from 'react'
import styled from 'styled-components'

interface PropsType {
  searchUrl: string
}

const Link = styled.a`
  align-items: center;
  background-color: #ec4444;
  border: solid 1px #e5003c;
  color: #fff;
  display: flex;
  font-weight: bold;
  height: 50px;
  justify-content: center;
  padding: 0 33px;
  text-align: center;
  width: 215px;

  &:hover {
    background-color: #e02b2b;
    text-decoration: none;
  }

  &:active {
    color: #b32424;
  }

  &:visited {
    color: #fff;
  }
`

const SearchButton = (props: PropsType) => {
  return <Link href={props.searchUrl}>この条件で検索する</Link>
}

export default SearchButton
